var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageIndicator"},_vm._l((_vm.pagesArray),function(page,index){return _c('div',{key:index,staticClass:"PageIndicator__dot",class:{ 'PageIndicator__dot-active': page }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }